import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import HelpOutline from "@material-ui/icons/HelpOutline";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 20,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
  button: {
    margin: 15,
  },
});

const SyncfromTeams = (props) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  const updateHandler = (updateType) => {
    clearAlert();
    setLoading(true);

    let success = false;

    fetchWithToken(`api/TeamsUpdate/${updateType}`)
      .then((res) => {
        if (res.ok) success = true;
        return res.json();
      })
      .then((data) => {
        console.log("data", data);
        sendAlert(data.returnMessage, success ? "success" : "warning");
        setLoading(false);
      });
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card
            className={classes.card}
            style={!alertMessage.active ? { marginTop: "68px" } : null}
          >
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <CardContent>
              <Typography
                sx={{ fontSize: 14 }}
                style={{ margin: "20px", fontSize: "1.5em" }}
                color="text.secondary"
                gutterBottom
              >
                Sync From Teams
                <Tooltip
                  title="The buttons below are to sync DMV with Teams data."
                  placement="right"
                >
                  <IconButton color="primary" component="label">
                    <HelpOutline />
                  </IconButton>
                </Tooltip>
              </Typography>
              {loading && (
                <>
                  <div style={{ margin: "25px" }}>
                    <span style={{ display: "table", margin: "0 auto" }}>
                      Please Wait Sync to Finish
                    </span>
                    <LinearProgress />
                  </div>
                </>
              )}

              <div class="d-flex justify-content-center">
                <div class="btn-group" style={{ marginBottom: "20px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    disabled={loading}
                    onClick={() => updateHandler("RunDialPlanDataSync")}
                  >
                    Sync Dial Plans
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    disabled={loading}
                    onClick={() => updateHandler("RunVoiceDataSync")}
                  >
                    Sync Voice Policies
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default SyncfromTeams;
